import {
  faArrowLeft,
  faArrowRight,
  faArrowToLeft,
  faArrowToRight,
  faEllipsis
} from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ButtonLink from 'components/shared/ButtonLink.styled';
import { useRouter } from 'next/dist/client/router';
import Link from 'next/link';
import { Fragment } from 'react';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import { StyledEllipsis, StyledPagination } from './BlogPagination.styled';

type BlogPaginationProps = {
  totalPosts?: number;
  totalPages?: number;
  currentPage?: number;
  category?: string;
};

const ellipsis = (
  <StyledEllipsis>
    <FontAwesomeIcon icon={faEllipsis} />
  </StyledEllipsis>
);

const BlogPagination: React.FC<BlogPaginationProps> = ({
  totalPages,
  currentPage,
  category
}) => {
  const { locale } = useRouter();

  const pages = totalPages || 0;
  const page = currentPage || 1;
  const pagerPrefix = category
    ? `${getAppUrl(
        APP_URLS.talentEngineBlog,
        locale
      )}/category/${category}/page/`
    : `${getAppUrl(APP_URLS.talentEngineBlog, locale)}/page/`;

  return (
    <StyledPagination>
      {pages > 1 && page > 1 && (
        <>
          <Link href={`${pagerPrefix}1`} passHref>
            <ButtonLink sizes="sm" variant="secondary" isIcon>
              <FontAwesomeIcon icon={faArrowToLeft} />
            </ButtonLink>
          </Link>

          <Link href={`${pagerPrefix}${page - 1}`} passHref>
            <ButtonLink sizes="sm" variant="secondary" isIcon>
              <FontAwesomeIcon icon={faArrowLeft} />
            </ButtonLink>
          </Link>
        </>
      )}

      {page - 2 > 0 && ellipsis}

      {[...Array(pages)].map((p, i) => (
        <Fragment key={`${pagerPrefix}${i + 1}`}>
          {i + 1 >= page - 1 && i + 1 <= page + 1 && (
            <Link href={`${pagerPrefix}${i + 1}`} passHref>
              <ButtonLink
                sizes="sm"
                variant={page === i + 1 ? 'active' : 'secondary'}
                isIcon
                className="number"
              >
                <span>{i + 1}</span>
              </ButtonLink>
            </Link>
          )}
        </Fragment>
      ))}

      {page + 2 <= pages && ellipsis}

      {pages > 1 && page < pages && (
        <>
          <Link href={`${pagerPrefix}${page + 1}`} passHref>
            <ButtonLink sizes="sm" variant="secondary" isIcon>
              <FontAwesomeIcon icon={faArrowRight} />
            </ButtonLink>
          </Link>
          <Link href={`${pagerPrefix}${pages}`} passHref>
            <ButtonLink sizes="sm" variant="secondary" isIcon>
              <FontAwesomeIcon icon={faArrowToRight} />
            </ButtonLink>
          </Link>
        </>
      )}
    </StyledPagination>
  );
};

export default BlogPagination;
